const delegate = require('emmy/delegate');
const domify = require('domify');
const q = require('queried');

function sendPixel(url) {
  const random = String(Math.random()).replace('.', '');
  const divider = url.includes('?') ? '&' : '?';
  const img = domify(`
    <img
      src="${url}${divider}rnd=${random}"
      width="1"
      height="1"
      style="opacity: .001; position: absolute;"
    >
  `);
  document.body.appendChild(img);
}

function bindCountersClick() {
  delegate(document.body, 'click', '[data-click-pixel]', (e) => {
    const item = e.delegateTarget;

    const url = item.getAttribute('data-click-pixel');
    sendPixel(url);
    item.removeAttribute('data-click-pixel');
  });
}

function sendCountersView() {
  q.all('[data-view-pixel]').forEach((item) => {
    const url = item.getAttribute('data-view-pixel');
    sendPixel(url);
    item.removeAttribute('data-view-pixel');
  });
}

module.exports = {
  sendPixel,
  sendCountersView,
  bindCountersClick,
};
